var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.config.view === "button"
        ? _c(
            "a",
            {
              staticClass: "btn btn-primary btn-icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onProductAdd(_vm.productId)
                }
              }
            },
            [
              _c("span", [_vm._v("Add to Cart")]),
              _vm._v(" "),
              _vm.loading
                ? _c("i", [
                    _c("span", {
                      staticClass: "spinner-border spinner-border-sm"
                    })
                  ])
                : _c("i", { staticClass: "icon-shopping-bag" })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.config.view === "full"
        ? _c("div", { staticClass: "add-to-cart-container" }, [
            _c("div", { staticClass: "add-to-cart-mobile" }, [
              _c(
                "div",
                { staticClass: "add-to-cart-mobile__quantity" },
                [
                  _c("SelectMenu", {
                    attrs: {
                      options: _vm.quantities,
                      label: "I want to use it for"
                    },
                    model: {
                      value: _vm.formQuantity,
                      callback: function($$v) {
                        _vm.formQuantity = _vm._n($$v)
                      },
                      expression: "formQuantity"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "add-to-cart-mobile__price" }, [
                _c("div", { staticClass: "add-to-cart-mobile__price-value" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.formPrice) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-to-cart-mobile__price-info" }, [
                  _vm._v("(VAT incl.)")
                ]),
                _vm._v(" "),
                _vm.formPriceRule
                  ? _c("div", [
                      _c(
                        "span",
                        { staticClass: "badge badge-pill badge-extra-light" },
                        [_vm._v("save " + _vm._s(_vm.formPriceRule))]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-to-cart-mobile__button" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-one-icon",
                    on: {
                      click: function($event) {
                        return _vm.onProductAdd(_vm.productId)
                      }
                    }
                  },
                  [_vm._m(0)]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-to-cart" }, [
              _c(
                "div",
                { staticClass: "add-to-cart__quantity" },
                [
                  _c("SelectMenu", {
                    attrs: {
                      options: _vm.quantities,
                      label: "I want to use it for"
                    },
                    model: {
                      value: _vm.formQuantity,
                      callback: function($$v) {
                        _vm.formQuantity = _vm._n($$v)
                      },
                      expression: "formQuantity"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "add-to-cart__price" }, [
                _c("div", { staticClass: "add-to-cart__price-value" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.formPrice) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-to-cart__price-info text-sm" }, [
                  _vm._v("(VAT incl.)")
                ]),
                _vm._v(" "),
                _vm.formPriceRule
                  ? _c("div", [
                      _c(
                        "span",
                        { staticClass: "badge badge-pill badge-white" },
                        [_vm._v("save " + _vm._s(_vm.formPriceRule))]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "add-to-cart__button" }, [
                _vm.config.supportPeriod
                  ? _c(
                      "ul",
                      { staticClass: "add-to-cart__button-info list-benefits" },
                      [
                        _c("li", [_vm._v("14-day money-back guarantee")]),
                        _vm._v(" "),
                        _c("li", [_vm._v("Future product updates")]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            _vm._s(_vm.config.supportPeriod) + " months support"
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.onProductAdd(_vm.productId)
                      }
                    }
                  },
                  [_c("span", [_vm._v("Add to Cart")])]
                ),
                _vm._v(" "),
                _vm.config.demoUrl
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "link-icon",
                          attrs: { href: _vm.config.demoUrl, target: "_blank" }
                        },
                        [
                          _c("i", { staticClass: "icon-eye" }),
                          _vm._v(" Live demo")
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.config.documentationUrl || _vm.config.licenseUrl
                ? _c("div", { staticClass: "add-to-cart__links" }, [
                    _vm.config.documentationUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "link-icon",
                            attrs: {
                              href: _vm.config.documentationUrl,
                              target: "_blank"
                            }
                          },
                          [
                            _c("i", { staticClass: "icon-book-open" }),
                            _vm._v(" Documentation")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.config.licenseUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "link-icon",
                            attrs: { href: _vm.config.licenseUrl }
                          },
                          [
                            _c("i", { staticClass: "icon-clipboard" }),
                            _vm._v(" License")
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.product !== null
        ? _c("Modal", {
            attrs: { cssClass: "product-cart", id: "modal-product-cart" },
            on: { close: _vm.onModalClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "alert",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "alert alert-success" }, [
                        _c("p", [
                          _vm._v(
                            "The product has been added to your shopping cart."
                          )
                        ])
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "cart-modal" }, [
                        _c(
                          "div",
                          { staticClass: "cart-modal__main" },
                          [
                            _vm.loading
                              ? [
                                  _c("Loading", {
                                    attrs: { "css-class": "loading--cover" }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "cart-modal__product" }, [
                              _c(
                                "div",
                                { staticClass: "cart-modal__product-row" },
                                [
                                  _c("div", { staticClass: "flex-grow-1" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cart-modal__product-name"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.product.name) +
                                            "\n\n                                    "
                                        ),
                                        _vm.modalPriceRule
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "cart-modal__product-name-badge"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-pill badge-extra-light"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "save " +
                                                        _vm._s(
                                                          _vm.modalPriceRule
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cart-modal__product-quantity"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.modalQuantity) +
                                            " Licenses\n                                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml-auto" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product-price product-price--block product-price--lg"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "product-price__value"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(_vm.modalPrice) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "product-price__text"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        (VAT incl.)\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "quantity-selection" }, [
                              _c(
                                "div",
                                { staticClass: "cart-modal__headline" },
                                [_vm._v("Buy More Pay Less")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "quantity-selection__list" },
                                _vm._l(_vm.quantities, function(quantity) {
                                  return _c(
                                    "button",
                                    {
                                      staticClass: "quantity-selection__btn",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          quantity.value === _vm.modalQuantity
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.onProductQuantityUpdate(
                                            quantity
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(quantity.label) +
                                          "\n                                "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "quantity-selection__price"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "quantity-selection__price-value"
                                            },
                                            [_vm._v(_vm._s(quantity.price))]
                                          ),
                                          quantity.value > 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "quantity-selection__price-text"
                                                },
                                                [_vm._v(" / license")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "cart-modal__buttons-group buttons-group buttons-group--no-wrap"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary btn-icon",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.showModal = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "d-none d-xl-inline" },
                                      [_vm._v("Continue Shopping")]
                                    ),
                                    _c("span", { staticClass: "d-xl-none" }, [
                                      _vm._v("Back")
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "icon icon-chevron-left"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary btn-icon",
                                    attrs: {
                                      href: _vm.config.checkoutUrl,
                                      title: "Checkout"
                                    }
                                  },
                                  [
                                    _vm._v("Checkout "),
                                    _c("i", {
                                      staticClass: "icon icon-shopping-bag"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.services.length > 0
                          ? _c("div", { staticClass: "cart-modal__services" }, [
                              _c(
                                "div",
                                { staticClass: "cart-modal__headline" },
                                [_vm._v("Additional Services")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cart-modal__services-list" },
                                _vm._l(_vm.services, function(service) {
                                  return _c(
                                    "div",
                                    { staticClass: "cart-modal__service" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cart-modal__service-inside"
                                        },
                                        [
                                          service.icon
                                            ? _c("div", {
                                                staticClass:
                                                  "cart-modal__service-image",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    "<i data-icon='&#x" +
                                                      service.icon +
                                                      ";'></i>"
                                                  )
                                                }
                                              })
                                            : service.image
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cart-modal__service-image"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: service.image,
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cart-modal__service-row"
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "cart-modal__service-name"
                                                  },
                                                  [_vm._v(_vm._s(service.name))]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cart-modal__service-price"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product-price product-price--cart-modal-service"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price__value"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              service.price
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product-price__text"
                                                        },
                                                        [_vm._v("(VAT incl.)")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cart-modal__service-buttons"
                                            },
                                            [
                                              service.teaser
                                                ? _c(
                                                    "button",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy",
                                                          value: [
                                                            "xs",
                                                            "sm"
                                                          ].includes(_vm.$mq)
                                                            ? {
                                                                placement:
                                                                  "bottom",
                                                                maxWidth: 260
                                                              }
                                                            : {
                                                                placement:
                                                                  "left-start"
                                                              },
                                                          expression:
                                                            "['xs', 'sm'].includes($mq) ? { placement : 'bottom', maxWidth : 260 } : { placement : 'left-start' }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "cart-modal__service-buttons-info btn btn-secondary btn-one-icon btn-one-icon--md rounded-circle",
                                                      attrs: {
                                                        content: service.teaser
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon icon-info"
                                                      })
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              service.quantity > 0
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-one-icon btn-one-icon--md rounded-circle",
                                                      attrs: {
                                                        disabled:
                                                          _vm.loadingServiceId
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onServiceRemove(
                                                            service
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass: "icon",
                                                        class:
                                                          _vm.loadingServiceId ===
                                                          service.id
                                                            ? "spinner-border spinner-border-sm"
                                                            : "icon-x"
                                                      })
                                                    ]
                                                  )
                                                : _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-primary btn-one-icon btn-one-icon--md rounded-circle",
                                                      attrs: {
                                                        disabled:
                                                          _vm.loadingServiceId
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onServiceAdd(
                                                            service
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass: "icon",
                                                        class:
                                                          _vm.loadingServiceId ===
                                                          service.id
                                                            ? "spinner-border spinner-border-sm"
                                                            : "icon-shopping-bag"
                                                      })
                                                    ]
                                                  )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              4178419600
            ),
            model: {
              value: _vm.showModal,
              callback: function($$v) {
                _vm.showModal = $$v
              },
              expression: "showModal"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "icon-shopping-bag" }, [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Add to Cart")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }